import Header from "./components/Header.js"
import Input from "./components/Input.js"
import Footer from "./components/Footer.js"
function App(){

    return(
        <div className="container">
          <Header title="bookfinder"/>   
          <Input />
          <Footer />
        </div>
    )
}

export default App


